var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsio-user-position" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.userPositionOn,
            expression: "userPositionOn",
          },
        ],
        staticClass: "userPositionOn",
        attrs: { id: "userPositionOn_" + _vm.instanceId, type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.userPositionOn)
            ? _vm._i(_vm.userPositionOn, null) > -1
            : _vm.userPositionOn,
        },
        on: {
          click: function ($event) {
            _vm.userPositionClick = true
          },
          change: function ($event) {
            var $$a = _vm.userPositionOn,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.userPositionOn = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.userPositionOn = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.userPositionOn = $$c
            }
          },
        },
      }),
      _c(
        "label",
        {
          staticClass: "lgrid-center-middle-equalHeight",
          attrs: { for: "userPositionOn_" + _vm.instanceId },
        },
        [
          _c("span", {
            staticClass: "label",
            domProps: {
              innerHTML: _vm._s(_vm.t.autourDeMoi || "Autour de moi"),
            },
          }),
          _vm._m(0),
        ]
      ),
      _vm.infoModal
        ? _c(
            "modal",
            {
              on: {
                cancel: _vm.disableUserPosition,
                apply: _vm.tryUserPosition,
              },
            },
            [
              _c(
                "h3",
                {
                  staticClass: "colored",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        (_vm.t.userInfoModal && _vm.t.userInfoModal.title) ||
                          "À savoir..."
                      ),
                    },
                  }),
                ]
              ),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      (_vm.t.userInfoModal && _vm.t.userInfoModal.msg) ||
                        "Afin d'afficher l'offre la plus proche de vous, nous allons vous demander votre géolocalisation."
                    ),
                  },
                }),
              ]),
              _c("template", { slot: "cancel" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      (_vm.t.userInfoModal && _vm.t.userInfoModal.cancel) ||
                        "Annuler"
                    ) +
                    "\n    "
                ),
              ]),
              _c("template", { slot: "apply" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      (_vm.t.userInfoModal && _vm.t.userInfoModal.apply) ||
                        "Continuer"
                    ) +
                    "\n    "
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "status" }, [
      _c("i", { staticClass: "dsio-street-view-light" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }